import React, { useEffect, useState } from 'react';
import emptyFolter from '../../../../assets/images/empty-folder 2.svg';
import { AddAlert, ExpandMore } from '@mui/icons-material';
import DoneIcon from '@mui/icons-material/Done';
import Searchicon from '../../../../assets/images/Search.svg';
import {
  TextField,
  Button,
  Select,
  IconButton,
  FormGroup,
  InputLabel,
  Grid,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Chip,
  Typography,
  FormHelperText,
} from '@mui/material';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import {
  Remove as MinusIcon,
  ArrowDropDown,
  ArrowDropUp,
} from '@mui/icons-material';
import { useHook as ControllerHook } from '../controllerPage/useHook';
import { useHook as RoleHook } from '../../Iam/rolemanagement/useHook';
import { useHook as EquipmentHook } from './useHook';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { closeIcon } from '../../../../assets/images/index';
import { setGetControllerDetails } from '../../../../stores/actionTypes/controllerActions';
import { UrlToBase } from '../../../../components/urlToBase64';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import {
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error"; // for "danger"
import CreateAlert from './createAlert';



const EquipmentsAlertsEditPage = (props: any) => {
  const { editData,setEquipmentsPage,setEquipmentsPayload,equipmentsPayload } = props;
  console.log(editData,"edit data")
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { controllerAllList, controllerDetails } = useSelector(
    (state: any) => state.controller,
  );
  const statusOptions = [
  { value: "info", label: "Info", icon: <InfoIcon color="info" /> },
  { value: "warning", label: "Warning", icon: <WarningIcon color="warning" /> },
  { value: "danger", label: "Danger", icon: <ErrorIcon color="error" /> },
];
const notificationOptions:any = ["push", "db", "email"];
  const [filteredControllerData, setFilteredControllerData] =
    useState<any>(controllerAllList);
  const [selectedControllerData, setSelectedControllerData] =
    useState<string>('');
  const { fetchAllControllerList, fetchGetControllerDetails } =
    ControllerHook();
  const { fetchGetAllRoleList } = RoleHook();
  const { createEquipment, editEquipment } = EquipmentHook();
const alertToEdit = editData?.events?.[0]; // pick the first alert safely



const [formData, setFormData] = useState<any>({
  eventType: alertToEdit ? alertToEdit.eventType : "",
  values: alertToEdit
    ? Object.entries(alertToEdit.value).map(([valKey, valData]: [string, any]) => ({
        value: valKey,          // dynamic key becomes value field
        title: valData.title,
        desc: valData.desc,
        icon: valData.icon,
        channels: valData.channels || [],
      }))
    : [
        {
          value: "",
          title: "",
          desc: "",
          icon: "",
          channels: [],
        },
      ],
});


 const handleSubmitEquipment = async () => {
    setIsActiveSubmitParam(false);
 
    if (editData) {
      const imageType = croppedImage?.substring(11, croppedImage?.indexOf(';'));
      const imageWithoutPrefix = croppedImage?.substring(
        croppedImage?.indexOf(',') + 1,
      );
      let primaryParameter = '';
      controllerParameter?.forEach((data: any) => {
        if (data?.primary) {
          primaryParameter = data?.controllerVariable;
        }
        // // Remove 'primary' key from the object
        // delete data.primary;
      });
      const editEquipmentPayload = {
        equipmentID: editData?.equipmentID,
        equipmentName: editData?.equipmentName,
        model: editData?.model,
        image: imageWithoutPrefix ? imageWithoutPrefix : '',
        ext: imageType ? imageType : '',
        category: editData?.category,
        subCategory: editData?.subCategory,
               controller: editData?.controller,
        //   primaryParameter: editData?.primaryParameter,
      };
   

          const payloadWithAlerts = {
            ...editData,
  ...editEquipmentPayload,
    events: alerts.map((alert:any) => ({
      eventType: alert.eventType,
      value: alert.values.reduce((acc: any, curr: any, index: number) => {
        acc[curr.value] = {
          title: curr.title,
          desc: curr.desc,
          icon: curr.icon,
          channels: curr.channels,
        };
        return acc;
      }, {}),
    })),
  };


      await editEquipment(payloadWithAlerts);
      navigate(-1);
    } 
    setActiveEditedData({});
  };

  const [controllerParameter, setControllerParameter] = useState<any>([]);
  const [expanded, setExpanded] = useState<number[]>([]);
  const [expandedForm, setExpandedForm] = useState<number[]>([]);
  const { allRole } = useSelector((state: any) => state.role);
  const [tagName, setTagName] = React.useState<string[]>([]);
  const [filteredRoles, setFilteredRoles] = useState<any[]>([]);
  const [selectedRole, setSelectedRole] = useState<string[]>([]);
  const [isActiveParam, setIsActiveParam] = useState(false);
  const [isActiveSubmitParam, setIsActiveSubmitParam] = useState(false);
  const [croppedImage, setCroppedImages] = useState<string | null>(null);
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const [isActive, setIsActive] = useState(false);
    const [openCategory, setOpenCategory] = useState(false);
    const [selectedCategory,setSelectedCategory] = useState("")
     const [selectedNotifications, setSelectedNotifications] = useState<any>([]);
const [alerts,setAlerts] = useState<any>([])
// initialize with API data if available
useEffect(() => {
  if (editData) {
    setAlerts(
        editData.events
        ?
      editData?.events?.map((alert: any) => ({
        eventType: alert.eventType,
        values: Object.entries(alert.value).map(
          ([valKey, valData]: [string, any]) => ({
            value: valKey,
            title: valData.title,
            desc: valData.desc,
            icon: valData.icon,
            channels: valData.channels || [],
          })
        ),
      }))
      :[]
    );
  }
}, [editData]);



  const handleNotificationsChange = (event:any) => {
    const {
      target: { value },
    } = event;
    setSelectedNotifications(typeof value === "string" ? value.split(",") : value);
  };


      const handleCloseCategory = () => {
    setOpenCategory(false);
  };
    const handleActiveChange = () => {
    setIsActive(true);
  };
  const [validationErrors, setValidationErrors] = useState<
 any
  >({});
  const [cotrollerOpen, setCotrollerOpen] = useState(false);
// Track edits like: { 0: [1,2], 1: [0] } 
// meaning: event 0 → values 1 & 2 edited, event 1 → value 0 edited
type ActiveEditedData = Record<
  number,
  { eventEdited?: boolean; valuesEdited?: number[] }
>;

const [activeEditedData, setActiveEditedData] = useState<ActiveEditedData>({});


  const handleCloseCotroller = () => {
    setCotrollerOpen(false);
    setFilteredControllerData(controllerAllList);
  };

  const getControllerList = async () => {
    await fetchAllControllerList({});
  };
  useEffect(() => {
    if (!(controllerAllList?.length > 0)) {
      getControllerList();
    }
    if (!(allRole?.length > 0)) {
      fetchGetAllRoleList({});
    }
    dispatch(setGetControllerDetails({}));
  }, []);

  useEffect(() => {
    setFilteredControllerData(controllerAllList);
  }, [controllerAllList]);

  useEffect(() => {
    if (editData) {
      setSelectedControllerData(editData?.controller?.controllerID);
      const addmissingValue = editData?.controller?.parameters?.map(
        (obj: any) => {
          return {
            order: obj?.order ? obj?.order : 0,
            decimals: obj?.decimals ? obj?.decimals : 2,
            minValue: obj?.minValue ? obj?.minValue : '0',
            maxValue: obj?.maxValue ? obj?.maxValue : '0',
            defaultValue: obj?.defaultValue ? obj?.defaultValue : 0,
            primary: obj?.controllerVariable
              ? obj?.controllerVariable === editData?.primaryParameter
              : false,
            ...obj,
          };
        },
      );
      setControllerParameter(addmissingValue);
    }
  }, [editData]);

  useEffect(() => {
    const paramData = {
      unit: 'A',
      decimals: 2,
      minValue: '0',
      maxValue: '0',
      defaultValue: 0,
      order: 0,
    };

    if (controllerDetails?.parameters) {
      const addedParamData = controllerDetails?.parameters?.map((obj: any) => {
        return {
          controllerVariable: obj?.variableName,
          parameterName: obj?.name,
          parameterComment: obj?.comment,
          accessPermissions: obj?.accessPermissions,
          customerAccess: obj?.customerAccess,
          behaviour: obj?.behaviour,
          ...paramData, // Spread the paramData values to add
        };
      });
      setControllerParameter(addedParamData);
    } else {
      if (editData) {
        const addmissingValue = editData?.controller?.parameters?.map(
          (obj: any) => {
            return {
              order: obj?.order ? obj?.order : 0,
              decimals: obj?.decimals ? obj?.decimals : 2,
              minValue: obj?.minValue ? obj?.minValue : '0',
              maxValue: obj?.maxValue ? obj?.maxValue : '0',
              defaultValue: obj?.defaultValue ? obj?.defaultValue : 0,
              primary: obj?.controllerVariable
                ? obj?.controllerVariable === editData?.primaryParameter
                : false,
              ...obj,
            };
          },
        );
        setControllerParameter(addmissingValue);
      }
    }
  }, [controllerDetails]);

  useEffect(() => {
    setFilteredRoles(allRole);
  }, [allRole]);

  const findrolename = (roleid: string) => {
    if (allRole?.length > 0) {
      if (roleid) {
        const findrole = allRole.find((param: any) => param.roleID == roleid);
        return findrole?.roleName ? findrole?.roleName : roleid;
      } else {
        return roleid;
      }
    } else {
      return roleid;
    }
  };

  const handleControllSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: any = controllerAllList?.filter((user: any) =>
      user?.controllerName?.toLowerCase().includes(query),
    );

    setFilteredControllerData(filtered);
  };

  const handleChangeTagName = (event: any) => {
    const {
      target: { value },
    } = event;
    setTagName(typeof value === 'string' ? value.split(',') : value);
    setIsActiveParam(true);
  };

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = allRole?.filter((role: { roleName: string }) =>
      role.roleName?.toLowerCase().includes(query),
    );
    setFilteredRoles(filtered);
  };

  const handleRoleSelection = (roleName: string | undefined) => {
    if (!roleName) return;
    setSelectedRole((prevselectedRole) => {
      if (prevselectedRole.includes(roleName)) {
        const updatedRoles = prevselectedRole.filter(
          (roles) => roles !== roleName,
        );
        return updatedRoles;
      } else {
        const updatedRoles = [...prevselectedRole, roleName];
        return updatedRoles;
      }
    });
    handleremoveError('role');
    setSeeMoreIndex(2);
  };

  const handleControllDisplay = async (controllerID: any) => {
    if (controllerID) {
      setSelectedControllerData(controllerID);
      if (editData && editData?.controller?.controllerID === controllerID) {
        setControllerParameter(editData?.controller?.parameters);
      } else {
        await fetchGetControllerDetails({ controllerID });
      }
    } else {
      setSelectedControllerData('');
    }
    setExpandedForm([]);
    setExpanded([]);
    setValidationErrors({});
    setIsActiveParam(false);
    setIsActiveSubmitParam(true);
  };

const validateForm = () => {

  const errors: any = {};

  // ✅ Validate eventType
  if (!formData.eventType || formData.eventType.trim() === "") {
    errors.eventType = "Event Type is required";
  }

  // ✅ Validate each value object
  errors.values = formData.values.map((val: any, index: number) => {
    const valueErrors: any = {};

    if (!val.title || val.title.trim() === "") {
      valueErrors.title = "Title is required";
    }
    if (!val.desc || val.desc.trim() === "") {
      valueErrors.desc = "Description is required";
    }
    if (!val.icon || val.icon.trim() === "") {
      valueErrors.icon = "Icon is required";
    }
    if (!val.channels || val.channels.length === 0) {
      valueErrors.channels = "At least one channel is required";
    }

    return valueErrors;
  });

  // Check if any valueErrors are non-empty
  const hasValueErrors = errors.values.some(
    (valErrors: any) => Object.keys(valErrors).length > 0
  );


  setValidationErrors(errors);
  return !errors.eventType && !hasValueErrors;
};



  const handleremoveError = (name: string) => {
    if (!name) return;
    // const updateError = { ...validationErrors };
    // delete updateError[name];
    // setValidationErrors(updateError);

    // Create a copy of the current validation errors
    setValidationErrors((prevErrors:any) => {
      // Use a new object to avoid mutating the previous state directly
      const { [name]: _, ...updatedErrors } = prevErrors;
      return updatedErrors;
    });
  };




  const toggleExpanded = (index: number) => {
    if (expandedForm?.includes(index)) {
      setExpandedForm([]);
    } else {
      if (expanded?.includes(index)) {
        const removedExpand = expanded.filter((item: number) => item !== index);
        setExpanded(removedExpand);
      } else {
        setExpanded([...expanded, index]);
      }
    }
    setValidationErrors({});
    setIsActiveParam(false);
  };

  const toggleFormExpanded = (index: number) => {
    if (expandedForm?.includes(index)) {
      setExpandedForm([]);
    } else {
      setExpandedForm([index]);
    }
    const removedExpand = expanded.filter((item: number) => item !== index);
    setExpanded(removedExpand);
    setValidationErrors({});
    setIsActiveParam(false);
  };

  useEffect(() => {
    if (editData) {
      const imageUrl = editData?.image;
      if (imageUrl) {
        UrlToBase(imageUrl)
          .then((base64String) => {
            setCroppedImages(base64String);
          })
          .catch((error) => console.error(error));
      }
    }
  }, [editData]);

  const [editIndex, setEditIndex] = useState<number | null>(null);



const handleAddAlert = async (data: any) => {
  setIsActiveSubmitParam(false);

  const newAlert = {
    eventType: data.eventType,
    values: data.values,
  };

  if (editIndex !== null) {
    const oldAlert = alerts[editIndex] ?? { eventType: "", values: [] };

    // which value rows changed?
    const changedValueIndexes = newAlert.values.reduce((acc: number[], newVal: any, vIndex: number) => {
      const oldVal = oldAlert.values?.[vIndex];

      const channelsChanged =
        JSON.stringify(oldVal?.channels || []) !== JSON.stringify(newVal.channels || []);

      const isChanged =
        !oldVal ||
        oldVal.value !== newVal.value ||
        oldVal.title !== newVal.title ||
        oldVal.desc !== newVal.desc ||
        oldVal.icon !== newVal.icon ||
        channelsChanged;

      if (isChanged) acc.push(vIndex);
      return acc;
    }, []);

    const eventTypeChanged = oldAlert.eventType !== newAlert.eventType;

    // update alerts array
    setAlerts((prev: any[]) => prev.map((alert, i) => (i === editIndex ? newAlert : alert)));

    // merge with existing tracked edits for this event (don’t lose prior edits)
    setActiveEditedData((prev) => {
      const prevEntry = prev[editIndex] || { eventEdited: false, valuesEdited: [] };
      const mergedValues = Array.from(new Set([...(prevEntry.valuesEdited || []), ...changedValueIndexes]));

      return {
        ...prev,
        [editIndex]: {
          eventEdited: prevEntry.eventEdited || eventTypeChanged,
          valuesEdited: mergedValues,
        },
      };
    });

    setEditIndex(null);
  } else {
    // add new alert -> mark event and all its values as edited
    setAlerts((prev: any[]) => {
      const updated = [...(prev || []), newAlert];
      const newIndex = updated.length - 1;

      setActiveEditedData((prevState) => ({
        ...prevState,
        [newIndex]: {
          eventEdited: true,
          valuesEdited: newAlert.values.map((_: any, i: number) => i),
        },
      }));

      return updated;
    });
  }

  reset({
    eventType: "",
    values: [{ value: "", title: "", desc: "", icon: "", channels: [] }],
  });
};


    const {
      register,
      handleSubmit,
      control,
      reset,
      formState: { errors },
    }:any = useForm({
      defaultValues: formData,
    });

const { fields, append, remove } = useFieldArray({
  control,
  name: "values", // this tells RHF to manage the `values[]` array
});

  return (
    <>
       
   

        <CreateAlert
  formData={formData}
  setFormData={setFormData}
  formSubmit={handleSubmitEquipment}
  alerts={alerts}
  reset={reset}
  setAlerts={setAlerts}
  editIndex={editIndex}
  setEditIndex={setEditIndex}
  statusOptions={statusOptions}
      handleSubmit={handleSubmit}
  handleAddAlert={handleAddAlert}
  register={register}
  errors={errors}
  editData={editData?.events}
  validationErrors={validationErrors}
  handleActiveChange={handleActiveChange}
  handleremoveError={handleremoveError}
  fields={fields}
  control={control}
  remove={remove}
append={append}
isActive={isActive}
activeEditedData={activeEditedData}
setActiveEditedData={setActiveEditedData}
edit ={true}
  />
  


    </>
  );
};
const MemoizedComponent = React.memo(EquipmentsAlertsEditPage);
export default MemoizedComponent;



//not showing errors, didsabled buttons --
//cursor pointer in heading ---
//remove disable if first value 


// {
//   "eventType": "test-edit-alert",
//   "values": [
//     {
//       "value": "test edit alert",
//       "title": "test edit alert",
//       "desc": "test edit alert",
//       "icon": "info",
//       "channels": [
//         "db"
//       ]
//     }
//   ]
// }

